import {svgIconWrapper} from '../svg-icon-wrapper';

import FormRegularCheck from './form-regular-check-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <FormRegularCheck {...validProps} />;
}

SvgComponent.iconName = 'formRegularCheck';

export const FormRegularCheckIcon = svgIconWrapper(SvgComponent);
